import React from 'react'
import Navbar from './Navbar'

const About = () => {
    return (
        <section className="resume-section" id="about">
            <Navbar />
            <div className="resume-section-content">
                <h1 className="mb-0">
                    Sajid Ashraf
                    <span className="text-primary">Khaki</span>
                </h1>
                <div className="subheading mb-5">
                    India · Srinagar, 190002.
                    <a href="mailto:sajidkhaki@gmail.com">sajidkhaki@gmail.com</a>
                </div>
                <p className="lead mb-5 text-capitalize">I am experienced fullstack --MERN developer.
                Computer Science Postgraduate from the University Of Kashmir.
                Microsoft student partner and Windows U-Crew Member
                </p>
                <div className="social-icons">
                    <a className="social-icon" href="https://www.linkedin.com/in/sajidkhaki"><i
                        className="fab fa-linkedin-in"></i></a>
                    <a className="social-icon" href="https://www.github.com/sajidkhaki"><i className="fab fa-github"></i></a>
                    <a className="social-icon" href="https://www.twitter.com/sajidkhakii"><i className="fab fa-twitter"></i></a>
                    <a className="social-icon" href="https://www.facebook.com/sajidkhaki"><i
                        className="fab fa-facebook-f"></i></a>
                </div>
            </div>
        </section>
    )
}

export default About